// Module
var code = "<md-content class=\"mn-module-body flex layout-column\">\r\n    <mn-table mn-model=\"{{vm.mnModel}}\" actions=\"vm.actions\" selectable=\"true\" toggle=\"vm.toggle\"\r\n              mn-query=\"vm.filter\" order=\"-id\"\r\n              reset=\"vm.reset\"></mn-table>\r\n</md-content>";
// Exports
module.exports = code;